import { render, staticRenderFns } from "./AttendancePostCreate.vue?vue&type=template&id=6932e2a2&scoped=true"
import script from "./AttendancePostCreate.vue?vue&type=script&lang=js"
export * from "./AttendancePostCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6932e2a2",
  null
  
)

export default component.exports